<template>
  <div
    class="ins-model"
    @click="hide_model"
    @touchstart="startMove"
    @touchend="endMove"
  >
    <div class="ins-model-main" @click.stop>
      <div class="ins-model-btn">
        <button
          class="ins-btn-close iconfont icon-cm-cancel-1-copy"
          @click="hide_model"
        ></button>
        <button
          class="ins-btn-prev"
          v-if="ins_post_index > 0"
          @click="prev_method"
        >
          <svg viewBox="0 0 100 100">
            <path
              stroke="white"
              stroke-width="10"
              d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
              class="arrow"
            ></path>
          </svg>
        </button>
        <button
          class="ins-btn-next"
          v-if="post_data_length > 0 && ins_post_index < post_data_length - 1"
          @click="next_method"
        >
          <svg viewBox="0 0 100 100">
            <path
              stroke="white"
              stroke-width="10"
              d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
              class="arrow"
              transform="translate(100, 100) rotate(180) "
            ></path>
          </svg>
        </button>
      </div>
      <div class="ins-mb-top d-md-none d-block">
        <p style="text-transform: uppercase;">
          <button @click="hide_model">
            <svg viewBox="0 0 100 100">
              <path
                stroke="black"
                stroke-width="10"
                d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
                class="arrow"
              ></path>
            </svg>
          </button>
          {{ $t('shop_the_look') }}
        </p>
      </div>
      <div class="ins-main-left">
        <v-lazy-img
          :data-url="ins_post.media && ins_post.media.url"
          :src='loadingImg'
          style="width: 100%; height: 100%; object-fit: cover"
        />
        <v-ins-dot
          v-for="(item, index) in ins_post.instagram_products"
          :key="'' + item.post_id + item.id + index"
          :ins_dot="item"
          :ins_dot_index="index"
          :show_some_index="show_some_index"
        ></v-ins-dot>
      </div>
      <div class="ins-main-right">
        <div class="ins-right-top">
          <h5 class="d-none d-md-block" style="text-transform: uppercase;">{{ $t('shop_the_look') }}</h5>
          <div class="ins-product-box">
            <div
              class="ins-product"
              v-for="(item, index) in ins_post.instagram_products"
              :key="'' + item.post_id + item.id + index"
              @mouseenter="show_some_index = index"
              @mouseleave="show_some_index = null"
            >
              <v-add-card-height
                v-if="item.product"
                :product="{
                  ...item.product,
                }"
                :ins_variants="item.variant ? [item.variant] : null"
                :url_search="
                  item.variant_id ? '?&variant=' + item.variant_id : false
                "
                :show_name="true"
                :show_start="false"
                :show_product_price="true"
                :fontSize="12"
                :regularFontSize="12"
                :add_cart="add_cart"
                buy_able_class="main_button"
                model="instagram"
                :button_title="button_title"
                :background_color="background_color"
                :text_color="text_color"
                :isPC="isPC"
                :show_product_model="show_product_model"
              ></v-add-card-height>
            </div>
          </div>
          <div class="ins-text-box">
            {{ ins_post.content }}
          </div>
        </div>
        <div class="ins-right-bottom">
          <div class="ins-home">
            <a
              :href="`https://www.instagram.com/${ins_user_name}/`"
              target="_blank"
            >
              FOLLOW @{{ ins_user_name }} INSTAGRAM
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loadingImg from "@/images/applications/instagram/loading.gif";
import vAddCardHeight from "../../common/addCardHight.vue";
import vInsDot from "./insDot.vue";
//import LazyImg from '../../LazyImg.vue';

export default {
  props: {
    ins_post: {
      //当前帖子信息
      type: Object,
      require: true,
    },
    hide_model: {
      type: Function,
    },
    show_product_model: {
      type: Function,
    },
    add_cart: {
      type: Function,
    },
    post_data_length: {}, //所有帖子长度
    ins_post_index: {}, //所有帖子index
    prev_method: {},
    next_method: {},
    theme: {},
    cart_type: {},
    ins_user_name:{},//ins账号为模块下设置的主账号
    ins_config:{},
    button_title: null, //按钮文本
    background_color:null, // 按钮背景颜色
    text_color:null// 按钮字体颜色
  },
  data() {
    return {
      startX: 0,
      loadingImg,
      show_some_index: null,
      isPC: !navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ),
    };
  },
  computed: {
    instagram_products() {
      let list = [];
      if (
        this.ins_post &&
        this.ins_post.instagram_products &&
        this.ins_post.instagram_products.length
      ) {
        list = this.ins_post.instagram_products;
      }
      return list;
    },
  },
  methods: {
    startMove(e) {
      this.startX = e.targetTouches[0].clientX; // 获取触控时x坐标
    },
    endMove(e) {
      let endX = e.changedTouches[0].clientX;
      let distance = endX - this.startX;
      if (distance > 50) {
        this.prev_method();
      } else if (distance < -50) {
        this.next_method();
      }
    },
  },
  components: {
    vAddCardHeight,
    vInsDot,
    //LazyImg,
  },
};
</script>
<style scoped lang='scss'>
.ins-model {
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 999;
  padding: 40px 60px;

  overflow-y: auto;
  .ins-model-main {
    width: 100%;
    max-width: 960px;
    // min-height: 650px;
    margin: 0 auto;
    position: relative;
    background-color: #eeeeee;
    transition:all 0.5s;
    -moz-transition:all 0.5s; /* Firefox 4 */
    -webkit-transition:all 0.5s; /* Safari and Chrome */
    -o-transition:all 0.5s;
    .ins-main-left {
      width: 66.666%;
      position: relative;
      text-align: center;
      .imgCard {
        vertical-align: top;
      }
      &:hover::v-deep {
        .ins-dot-index {
          opacity: 1;
          visibility: visible;
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
      }
    }
    .ins-main-right {
      background-color: white;
      position: absolute;
      top: 0;
      right: 0;
      width: 33.333%;
      height: 100%;
      padding: 0 0 12px;
      display: flex;
      flex-direction: column;
      .ins-right-top {
        padding-top: 15px;
        overflow-x: hidden;
        overflow-y: auto;
        flex: 1;
        & > * {
          margin: 0 20px;
        }
        h5 {
          font-size: 16px;
          font-weight: 500;
          color: #222222;
          line-height: 22px;
          letter-spacing: 1px;
        }
        .ins-product-box {
          margin: 0 10px;
          .ins-product {
            text-align: center;
            width: 50%;
            display: inline-block;
            padding: 6px 10px;
            vertical-align: top;
            &::v-deep {
              .item_gallery {
                max-width: 80px;
                max-height: 80px;
                margin: 0 auto;
              }
              .item_name {
                font-size: 12px;
                height: 32px;
                line-height: 16px;
                margin-top: 4px;
              }
              .item_price {
                .selectpricewrap {
                  line-height: 16px;
                  .product_price_price,
                  .product_price_cross {
                    line-height: 16px;
                  }
                }
              }
              .item_button {
                margin-top: 4px;
                padding: 7.5px 0;
                border: unset;
              }
            }
          }
        }
        .ins-text-box {
          padding-top: 20px;
        }
      }
      .ins-right-bottom {
        padding: 20px 20px 0;
        .ins-home {
          background: #eeeeee;
          padding: 8px 5px 7px;
          text-align: center;
          border-radius: 4px;
          a {
            font-size: 12px;
            font-weight: 500;
            color: #999999;
            line-height: 17px;
            display: block;
            text-decoration: none;
          }
        }
      }
    }
    .ins-mb-top {
      padding: 14px 0;
      position: relative;
      & > p {
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #222222;
        line-height: 22.5px;
        letter-spacing: 2px;
      }
      button {
        position: absolute;
        left: 4px;
        top: 3px;
        padding: 10px;
        cursor: pointer;
        svg {
          height: 14px;
        }
      }
    }
  }
  .ins-model-main_transform{
    // overflow: visible;
    pointer-events: none;
    -moz-transform: translate(-30%, 0) scale(0.8);
    transform: translate(-30%, 0) scale(0.8);
  }
  .ins-model-btn {
    button {
      width: 40px;
      height: 40px;
      line-height: 40px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: #ffffff;
      svg {
        width: 25px;
        path {
          fill: white;
        }
      }
    }
    .ins-btn-prev {
      left: -60px;
    }
    .ins-btn-next {
      right: -60px;
    }
    .ins-btn-close {
      position: fixed;
      top: 0;
      right: 0;
      transform: unset;
    }
  }
}
@media screen and(max-width: 768px) {
  .ins-model {
    padding: 0;
    .ins-model-main {
      overflow-y: auto;
      min-height: 100%;
      .ins-main-left {
        width: 100%;
      }
      .ins-main-right {
        position: relative;
        width: 100%;
        padding: 0 0 32px;
        .ins-right-top {
          overflow-x: unset;
          overflow-y: unset;
          & > * {
            margin: 0 18px;
          }
          h5 {
            margin-bottom: 8px;
          }
          .ins-product-box {
            margin: 0 6.5px;
            .ins-product {
              padding: 8px 11.5px;
            }
          }
          .ins-text-box {
            padding-top: 24px;
          }
        }
        .ins-right-bottom {
          padding-top: 24px;
        }
      }
    }
    .ins-model-btn {
      display: none;
    }
  }
}
</style>
